import { render, staticRenderFns } from "./InsHomeCat.vue?vue&type=template&id=059d14e6&scoped=true&"
import script from "./InsHomeCat.vue?vue&type=script&lang=ts&"
export * from "./InsHomeCat.vue?vue&type=script&lang=ts&"
import style0 from "./InsHomeCat.vue?vue&type=style&index=0&id=059d14e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059d14e6",
  null
  
)

export default component.exports